import { List, ListItem, ListItemButton } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const FunctionsComponent = ({ items, code }) => {
    const operations = ["sum", "average"];

    const [t, i18n] = useTranslation();
    const [result, setResult] = useState(null);
    const [selectedOperation, setSelectedOperation] = useState(null);

    useEffect(() => {
        if (selectedOperation === 0) {
            handleSum();
        } else if (selectedOperation === 1) {
            handleAverage();
        }
    }, [selectedOperation]);

    const handleSum = () => {
        let sum = 0;
        let validCount = 0;
        
        items.forEach((item, index) => {
            const fieldValue = item.fields[code];
            
            // Normalizar o valor: substituir vírgula por ponto e remover espaços
            let normalizedValue = fieldValue;
            if (fieldValue != null && fieldValue !== '') {
                normalizedValue = String(fieldValue).replace(',', '.').trim();
            }
            
            const numericValue = Number(normalizedValue);
            
            // Apenas somar se for um número válido
            if (!isNaN(numericValue) && fieldValue != null && fieldValue !== '') {
                sum += numericValue;
                validCount++;
            }
        });
        
        setResult(sum);
    }

    const handleAverage = () => {
        let sum = 0;
        let validCount = 0;
        
        items.forEach((item, index) => {
            const fieldValue = item.fields[code];
            
            // Normalizar o valor: substituir vírgula por ponto e remover espaços
            let normalizedValue = fieldValue;
            if (fieldValue != null && fieldValue !== '') {
                normalizedValue = String(fieldValue).replace(',', '.').trim();
            }
            
            const numericValue = Number(normalizedValue);
            
            // Apenas somar se for um número válido
            if (!isNaN(numericValue) && fieldValue != null && fieldValue !== '') {
                sum += numericValue;
                validCount++;
            }
        });
        
        const average = validCount > 0 ? sum / validCount : 0;
        setResult(average);
    }

    return (
        <div>
            <div className="relation-grid">
                <div className="relation-list">
                    <span className="text-title" style={{ marginLeft: "16px" }}>{t("NgeAvailableFunctions")}</span>
                    <List>
                        {
                            operations?.map((op, i) => (
                                <ListItem key={i}>
                                    <ListItemButton
                                        onClick={() => setSelectedOperation(i)}
                                        selected={i === selectedOperation}
                                    >
                                        <div className="text">{t("Nge" + op.charAt(0).toUpperCase() + op.slice(1))}</div>
                                    </ListItemButton>
                                </ListItem>
                            ))
                        }
                    </List>
                </div>
                {
                    result !== null &&
                    <div>
                        {t("NgeResult")}: {result}
                    </div>
                }
            </div>
        </div>
    )
};
